import React, { useCallback, useEffect, useState, Component } from 'react';
import { Navbar } from './components/Navbar';
import { TrustedBy } from './components/TrustedBy';
import { Footer } from './components/Footer';
import { HeroDMRV } from './components/v2/HeroDMRV';
import { FeaturesDMRV } from './components/v2/FeaturesDMRV';
import { ESGDataPlatform } from './components/v2/ESGDataPlatform';
import { ProductShowcaseDMRV } from './components/v2/ProductShowcaseDMRV';
import { StatsDMRV } from './components/v2/StatsDMRV';
import { CTASectionDMRV } from './components/v2/CTASectionDMRV';
import { CoffeeTraceability } from './pages/CoffeeTraceability';
import { CookstoveCredits } from './pages/CookstoveCredits';
import { ForestryREDD } from './pages/ForestryREDD';
import { Agroforestry } from './pages/Agroforestry';
import { RenewableEnergy } from './pages/RenewableEnergy';
import { GHGAccounting } from './pages/GHGAccounting';
import { IFRSS1S2Reporting } from './pages/IFRSS1S2Reporting';
import { About } from './pages/About';
import { Presentation } from './pages/Presentation';
import { CBAMCompliance } from './pages/CBAMCompliance';
import { EUDRDueDiligence } from './pages/EUDRDueDiligence';
import { CSRDUganda } from './pages/CSRDUganda';
import { ESGCourses } from './pages/ESGCourses';
import { CourseDetail } from './pages/CourseDetail';
import { ContactUs } from './pages/ContactUs';
import { ContactThanks } from './pages/ContactThanks';
const dmrvPages: Record<string, ComponentType> = {
  coffee: CoffeeTraceability,
  cookstoves: CookstoveCredits,
  forestry: ForestryREDD,
  agroforestry: Agroforestry,
  energy: RenewableEnergy,
  ghg: GHGAccounting,
  ifrs: IFRSS1S2Reporting,
  cbam: CBAMCompliance,
  eudr: EUDRDueDiligence,
  csrd: CSRDUganda,
  about: About,
  courses: ESGCourses,
  'course-foundations': CourseDetail,
  'course-banking': CourseDetail,
  'course-oilgas': CourseDetail,
  'course-manufacturing': CourseDetail,
  'course-afolu': CourseDetail,
  'course-executive': CourseDetail,
  'contact-us': ContactUs,
  'contact-thanks': ContactThanks
};
function getPageFromPath(): string {
  const path = window.location.pathname.replace(/^\//, '');
  return path || 'home';
}
export function App() {
  const [currentPage, setCurrentPage] = useState(getPageFromPath);
  useEffect(() => {
    // Browser back/forward
    const onPopState = () => setCurrentPage(getPageFromPath());
    window.addEventListener('popstate', onPopState);
    // Internal page navigation from child pages (e.g. course pages)
    const onNavigateEvent = (e: Event) => {
      const page = (e as CustomEvent<{
        page: string;
      }>).detail.page;
      const path = page === 'home' ? '/' : `/${page}`;
      window.history.pushState(null, '', path);
      setCurrentPage(page);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    };
    window.addEventListener('carbonsafe:navigate', onNavigateEvent);
    return () => {
      window.removeEventListener('popstate', onPopState);
      window.removeEventListener('carbonsafe:navigate', onNavigateEvent);
    };
  }, []);
  const handleNavigate = useCallback((page: string) => {
    const path = page === 'home' ? '/' : `/${page}`;
    window.history.pushState(null, '', path);
    setCurrentPage(page);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, []);
  if (currentPage === 'presentation') {
    return <Presentation onExit={() => handleNavigate('home')} data-id="element-0" />;
  }
  const DMRVPage = dmrvPages[currentPage];
  return <div className="w-full min-h-screen bg-white" data-id="element-1">
      <Navbar currentPage={currentPage} onNavigate={handleNavigate} data-id="element-2" />
      {DMRVPage ? <DMRVPage data-id="element-3" /> : <>
          <HeroDMRV data-id="element-4" />
          <TrustedBy data-id="element-5" />
          <FeaturesDMRV data-id="element-6" />
          <ESGDataPlatform data-id="element-7" />
          <ProductShowcaseDMRV data-id="element-8" />
          <StatsDMRV data-id="element-9" />
          <CTASectionDMRV data-id="element-10" />
          <Footer data-id="element-11" />
        </>}
    </div>;
}